module.exports = __webpack_public_path__ + "img/color-1.07dd3fe.png";